export const environment = {
  production: false,
  searchUrl: "https://stage.api.sds.basf.com:9446/api/search",
  advancedUserUrl: "https://stage.api.sds.basf.com:9446/api/isAdvancedUser",
  shortlinkUrl: "https://stage.api.sds.basf.com:9446/api/shortlink",
  qrlinkUrl: "https://stage.api.sds.basf.com:9446/api/qr",
  salesOrgUrl: "https://stage.api.sds.basf.com:9446/api/salesOrg",
  userFilterUrl: "https://stage.api.sds.basf.com:9446/api/user-filter",
  currentUserUrl: "https://stage.api.sds.basf.com:9446/api/user",
  viewUrl: "https://stage.api.sds.basf.com:9446/api/view",
  downloadUrl: "https://stage.api.sds.basf.com:9446/api/download",
  downloadZipUrl: "https://stage.api.sds.basf.com:9446/api/download-zip",
  releaseNotesUrl: "https://stage.api.sds.basf.com:9446/api/release-notes",
  feedbackUrl: "https://stage.api.sds.basf.com:9446/api/feedback",
  errorMessagesUrl: "https://stage.api.sds.basf.com:9446/api/error-messages",
  oidc: {
    authority: 'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/v2.0',
    clientId: 'e3f1d981-ece4-4ba4-a4b5-ced4758d2c0f',
    redirectUrl: 'https://qa.sds.basf.com/oauth/callback',
    postLogoutRedirectUri: 'https://qa.sds.basf.com',
    scopes: 'openid profile offline_access api://e3f1d981-ece4-4ba4-a4b5-ced4758d2c0f/user_impersonation',
    authorizationEndpoint: 'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/oauth2/v2.0/authorize',
    tokenEndpoint: 'https://login.microsoftonline.com/ecaa386b-c8df-4ce0-ad01-740cbdb5ba55/oauth2/v2.0/token'
  }
};
